import Vue from "vue";
import { Steps, Field, Input, Select, Tooltip, Button } from 'buefy';
import App from "./App.vue";

// Install necessary Buefy components only
Vue.use(Steps);
Vue.use(Field);
Vue.use(Input);
Vue.use(Select);
Vue.use(Tooltip);
Vue.use(Button);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#app");
